module.exports = __webpack_public_path__ + "img/Eduzz-11-es.d3a379a4.png";